import {
  ByteString2qc03wzjsovk as ByteString,
  Companion_getInstance28gds36m4006o as Companion_getInstance,
} from './ByteString.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
} from '../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  checkOffsetAndCount2b5icqlx5z1pu as checkOffsetAndCount,
  arrayRangeEquals1k0armei4gb4e as arrayRangeEquals,
} from './Util.mjs';
import { segment35wobhh99hrhg as segment } from './internal/SegmentedByteString.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Segmentnhwb43ukbiy3 as Segment } from './Segment.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function toByteString($this) {
  return new (ByteString())($this.b3x());
}
var SegmentedByteStringClass;
function SegmentedByteString() {
  if (SegmentedByteStringClass === VOID) {
    class $ extends ByteString() {
      constructor(segments, directory) {
        super(Companion_getInstance().s3w_1.z3u_1);
        this.q3w_1 = segments;
        this.r3w_1 = directory;
      }
      y3w() {
        return toByteString(this).y3w();
      }
      z3w(pos) {
        // Inline function 'okio.internal.commonInternalGet' call
        checkOffsetAndCount(fromInt(this.r3w_1[this.q3w_1.length - 1 | 0]), fromInt(pos), 1n);
        var segment_0 = segment(this, pos);
        var segmentOffset = segment_0 === 0 ? 0 : this.r3w_1[segment_0 - 1 | 0];
        var segmentPos = this.r3w_1[segment_0 + this.q3w_1.length | 0];
        return this.q3w_1[segment_0][(pos - segmentOffset | 0) + segmentPos | 0];
      }
      a3x() {
        // Inline function 'okio.internal.commonGetSize' call
        return this.r3w_1[this.q3w_1.length - 1 | 0];
      }
      b3x() {
        // Inline function 'okio.internal.commonToByteArray' call
        var result = new Int8Array(this.v2());
        var resultPos = 0;
        // Inline function 'okio.internal.forEachSegment' call
        var segmentCount = this.q3w_1.length;
        var s = 0;
        var pos = 0;
        while (s < segmentCount) {
          var segmentPos = this.r3w_1[segmentCount + s | 0];
          var nextSegmentOffset = this.r3w_1[s];
          var tmp0 = this.q3w_1[s];
          var byteCount = nextSegmentOffset - pos | 0;
          var tmp4 = resultPos;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = segmentPos + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, result, tmp4, segmentPos, endIndex);
          resultPos = resultPos + byteCount | 0;
          pos = nextSegmentOffset;
          s = s + 1 | 0;
        }
        return result;
      }
      c3x(buffer, offset, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        var endIndex = offset + byteCount | 0;
        var s = segment(this, offset);
        var pos = offset;
        while (pos < endIndex) {
          var segmentOffset = s === 0 ? 0 : this.r3w_1[s - 1 | 0];
          var segmentSize = this.r3w_1[s] - segmentOffset | 0;
          var segmentPos = this.r3w_1[this.q3w_1.length + s | 0];
          // Inline function 'kotlin.comparisons.minOf' call
          var b = segmentOffset + segmentSize | 0;
          var byteCount_0 = Math.min(endIndex, b) - pos | 0;
          var offset_0 = segmentPos + (pos - segmentOffset | 0) | 0;
          var data = this.q3w_1[s];
          var segment_0 = Segment().u3v(data, offset_0, offset_0 + byteCount_0 | 0, true, false);
          if (buffer.w3u_1 == null) {
            segment_0.s3v_1 = segment_0;
            segment_0.r3v_1 = segment_0.s3v_1;
            buffer.w3u_1 = segment_0.r3v_1;
          } else {
            ensureNotNull(ensureNotNull(buffer.w3u_1).s3v_1).x3v(segment_0);
          }
          pos = pos + byteCount_0 | 0;
          s = s + 1 | 0;
        }
        var tmp = buffer;
        // Inline function 'kotlin.Long.plus' call
        var this_0 = buffer.x3u_1;
        tmp.x3u_1 = add(this_0, fromInt(byteCount));
        return Unit_instance;
      }
      d3x(offset, other, otherOffset, byteCount) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonRangeEquals' call
          if (offset < 0 || offset > (this.v2() - byteCount | 0)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var otherOffset_0 = otherOffset;
          var endIndex = offset + byteCount | 0;
          var s = segment(this, offset);
          var pos = offset;
          while (pos < endIndex) {
            var segmentOffset = s === 0 ? 0 : this.r3w_1[s - 1 | 0];
            var segmentSize = this.r3w_1[s] - segmentOffset | 0;
            var segmentPos = this.r3w_1[this.q3w_1.length + s | 0];
            // Inline function 'kotlin.comparisons.minOf' call
            var b = segmentOffset + segmentSize | 0;
            var byteCount_0 = Math.min(endIndex, b) - pos | 0;
            var offset_0 = segmentPos + (pos - segmentOffset | 0) | 0;
            var data = this.q3w_1[s];
            if (!other.e3x(otherOffset_0, data, offset_0, byteCount_0)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            otherOffset_0 = otherOffset_0 + byteCount_0 | 0;
            pos = pos + byteCount_0 | 0;
            s = s + 1 | 0;
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      e3x(offset, other, otherOffset, byteCount) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonRangeEquals' call
          if (offset < 0 || offset > (this.v2() - byteCount | 0) || otherOffset < 0 || otherOffset > (other.length - byteCount | 0)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var otherOffset_0 = otherOffset;
          var endIndex = offset + byteCount | 0;
          var s = segment(this, offset);
          var pos = offset;
          while (pos < endIndex) {
            var segmentOffset = s === 0 ? 0 : this.r3w_1[s - 1 | 0];
            var segmentSize = this.r3w_1[s] - segmentOffset | 0;
            var segmentPos = this.r3w_1[this.q3w_1.length + s | 0];
            // Inline function 'kotlin.comparisons.minOf' call
            var b = segmentOffset + segmentSize | 0;
            var byteCount_0 = Math.min(endIndex, b) - pos | 0;
            var offset_0 = segmentPos + (pos - segmentOffset | 0) | 0;
            var data = this.q3w_1[s];
            if (!arrayRangeEquals(data, offset_0, other, otherOffset_0, byteCount_0)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            otherOffset_0 = otherOffset_0 + byteCount_0 | 0;
            pos = pos + byteCount_0 | 0;
            s = s + 1 | 0;
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      x3w() {
        return this.b3x();
      }
      equals(other) {
        // Inline function 'okio.internal.commonEquals' call
        var tmp;
        if (other === this) {
          tmp = true;
        } else {
          if (other instanceof ByteString()) {
            tmp = (other.v2() === this.v2() && this.d3x(0, other, 0, this.v2()));
          } else {
            tmp = false;
          }
        }
        return tmp;
      }
      hashCode() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonHashCode' call
          var result = this.a3v_1;
          if (!(result === 0)) {
            tmp$ret$0 = result;
            break $l$block;
          }
          result = 1;
          // Inline function 'okio.internal.forEachSegment' call
          var segmentCount = this.q3w_1.length;
          var s = 0;
          var pos = 0;
          while (s < segmentCount) {
            var segmentPos = this.r3w_1[segmentCount + s | 0];
            var nextSegmentOffset = this.r3w_1[s];
            var tmp0 = this.q3w_1[s];
            var i = segmentPos;
            var limit = segmentPos + (nextSegmentOffset - pos | 0) | 0;
            while (i < limit) {
              result = imul(31, result) + tmp0[i] | 0;
              i = i + 1 | 0;
            }
            pos = nextSegmentOffset;
            s = s + 1 | 0;
          }
          this.v3w(result);
          tmp$ret$0 = result;
        }
        return tmp$ret$0;
      }
      toString() {
        return toByteString(this).toString();
      }
    }
    initMetadataForClass($, 'SegmentedByteString');
    SegmentedByteStringClass = $;
  }
  return SegmentedByteStringClass;
}
//region block: exports
export {
  SegmentedByteString as SegmentedByteString5e5x58c4yl7l,
};
//endregion

//# sourceMappingURL=SegmentedByteString.mjs.map
